import { api } from './api';

export interface Variante {
  id: number;
  productoId: number;
  name: string;
  sku?: string;
  codigoBarras?: string;
  precioAdicional: number;
  isActive: boolean;
  producto?: {
    id: number;
    name: string;
    sku?: string;
    precioBase: number;
  };
  createdAt?: string;
  updatedAt?: string;
}

export interface VarianteCreate {
  productoId: number;
  name: string;
  sku?: string;
  codigoBarras?: string;
  precioAdicional?: number;
}

export interface VarianteUpdate {
  name?: string;
  sku?: string;
  codigoBarras?: string;
  precioAdicional?: number;
  isActive?: boolean;
}

export interface PaginatedResponse<T> {
  data: {
    [key: string]: T[];
    pagination: {
      total: number;
      page: number;
      limit: number;
      totalPages: number;
    };
  };
}

export const varianteService = {
  getAll: async (
    productoId?: number,
    page = 1,
    limit = 50
  ): Promise<PaginatedResponse<Variante>> => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    });
    if (productoId) params.append('productoId', productoId.toString());
    
    const response = await api.get<PaginatedResponse<Variante>>(`/variantes?${params}`);
    return response.data;
  },

  getById: async (id: number): Promise<{ data: { variante: Variante } }> => {
    const response = await api.get<{ data: { variante: Variante } }>(`/variantes/${id}`);
    return response.data;
  },

  create: async (data: VarianteCreate): Promise<{ data: { variante: Variante } }> => {
    const response = await api.post<{ data: { variante: Variante } }>('/variantes', data);
    return response.data;
  },

  update: async (id: number, data: VarianteUpdate): Promise<{ data: { variante: Variante } }> => {
    const response = await api.put<{ data: { variante: Variante } }>(`/variantes/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<{ message: string }> => {
    const response = await api.delete<{ message: string }>(`/variantes/${id}`);
    return response.data;
  }
};

